import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import { useParams, useSearchParams } from 'react-router-dom';
import SupplierNotificationDetail from '@app/pages/customer/supplier-notification/SupplierNotificationDetail.tsx';
import { PermissionTypesEnum, SupplierNotificationTypeEnum } from '@api/ringil-api.v2.tsx';
import SupplierNotificationDetailDap from '@app/pages/dap/SupplierNotificationDetailDap.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';

interface ComponentProps {
}

const SupplierReservationDetailPage: React.FC<ComponentProps> = () => {
  const { tr } = useTranslationLgs();

  const { supplierNotificationId } = useParams();
  const [searchParams] = useSearchParams();

  const snType = searchParams.get('snType');
  const typ: SupplierNotificationTypeEnum = (snType as SupplierNotificationTypeEnum) || SupplierNotificationTypeEnum.EFXX;

  const oneOfPermission =
    typ === SupplierNotificationTypeEnum.DXX
      ? [
          PermissionTypesEnum.PERMISSION_SN_DXX_DETAIL_TAB_SN_READ,
          PermissionTypesEnum.PERMISSION_SN_DXX_DETAIL_TAB_SN_RW,
          PermissionTypesEnum.PERMISSION_SN_DXX_DETAIL_TAB_SN_INTERNALINFO_READ,
          PermissionTypesEnum.PERMISSION_SN_DXX_DETAIL_TAB_SN_INTERNALINFO_RW,
          PermissionTypesEnum.PERMISSION_SN_DXX_DETAIL_TAB_SN_ATTACHMENTS_READ,
          PermissionTypesEnum.PERMISSION_SN_DXX_DETAIL_TAB_SN_ATTACHMENTS_RW,
          PermissionTypesEnum.PERMISSION_SN_DXX_DETAIL_TAB_SN_CHAT_READ,
          PermissionTypesEnum.PERMISSION_SN_DXX_DETAIL_TAB_SN_CHAT_RW,
          PermissionTypesEnum.PERMISSION_SN_DXX_DETAIL_TAB_CUSTOMS_READ,
          PermissionTypesEnum.PERMISSION_SN_DXX_DETAIL_TAB_CUSTOMS_RW,
        ]
      : [
          PermissionTypesEnum.PERMISSION_SN_EFXX_DETAIL_TAB_SN_READ,
          PermissionTypesEnum.PERMISSION_SN_EFXX_DETAIL_TAB_SN_RW,
          PermissionTypesEnum.PERMISSION_SN_EFXX_DETAIL_TAB_SN_INTERNALINFO_READ,
          PermissionTypesEnum.PERMISSION_SN_EFXX_DETAIL_TAB_SN_INTERNALINFO_RW,
          PermissionTypesEnum.PERMISSION_SN_EFXX_DETAIL_TAB_SN_ATTACHMENTS_READ,
          PermissionTypesEnum.PERMISSION_SN_EFXX_DETAIL_TAB_SN_ATTACHMENTS_RW,
          PermissionTypesEnum.PERMISSION_SN_EFXX_DETAIL_TAB_SN_CHAT_READ,
          PermissionTypesEnum.PERMISSION_SN_EFXX_DETAIL_TAB_SN_CHAT_RW,
        ];

  return (
    <>
      <ResponsiveLayout title={tr(`SupplierReservationDetailPage.title`, `Supplier notification detail`)} oneOfPermission={oneOfPermission}>
        {typ === SupplierNotificationTypeEnum.EFXX && (
          <SupplierNotificationDetail supplierNotificationId={supplierNotificationId} />
        )}
        {typ === SupplierNotificationTypeEnum.DXX &&
          <SupplierNotificationDetailDap supplierNotificationId={supplierNotificationId} />}
      </ResponsiveLayout>
    </>
  );
};

export default withAuthenticationRequired(SupplierReservationDetailPage);
